import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ddt from '@wix/da-ddt';
import { initialize, refresh } from '../redux/actions';
import { getInitResponse, getFormStatus } from '../redux/selectors';
import { createSelector } from 'reselect';
import { InitResponse } from '../redux/types';

const logger = ddt.createLogger('submit');

const getFormStatusSelector = createSelector(
  state => state,
  state => ({
    response: getInitResponse(state),
    formStatus: getFormStatus(state),
  })
);

export function useSubmitInitialization(deviationId: number) {
  const dispatch = useDispatch();
  const { formStatus, response } = useSelector<any, any>(getFormStatusSelector);

  const initResponse = response?.deviation ? (response as InitResponse) : undefined;

  const refreshInitData = useCallback(() => {
    dispatch(refresh({ deviationId }));
  }, [dispatch, deviationId]);

  // Fetch the init data
  useEffect(() => {
    if (formStatus === 'uninitialized' && !!deviationId) {
      logger.log('Initializing');
      dispatch(initialize({ deviationId }));
    }
  }, [formStatus, dispatch, deviationId]);

  return { formStatus, initResponse, refreshInitData };
}
